import { Drawer } from "@aurem/ui";
import { useCallback } from "react";
import { MoreContent } from "./MoreContent";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const MoreDrawer = ({ open, onClose }: Props) => {
  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Drawer open={open} onOpenChange={handleOpenChange} side="bottom">
      {open && <MoreContent onClose={onClose} />}
    </Drawer>
  );
};
